// extracted by mini-css-extract-plugin
export default {"buttonText":"mtoHoD_2FRErLZwewcma"};